var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 30,
    r: 29.5,
    fill: "#4EBBB8",
    fillOpacity: 0.02,
    stroke: "#4EBBB8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 23.449C19.5 22.8844 19.9025 22.4259 20.3995 22.4259H23.5087C24.1258 22.4072 24.6707 21.9604 24.8807 21.3L24.9157 21.1834L25.0498 20.7272C25.1315 20.4472 25.2027 20.2022 25.303 19.984C25.6973 19.1219 26.4277 18.5234 27.2712 18.3705C27.4858 18.332 27.711 18.332 27.9712 18.332H32.0288C32.289 18.332 32.5153 18.332 32.7288 18.3705C33.5723 18.5234 34.3038 19.1219 34.697 19.984C34.7973 20.2022 34.8685 20.446 34.9502 20.7272L35.0843 21.1834L35.1193 21.3C35.3293 21.9604 35.9827 22.4084 36.601 22.4259H39.5993C40.0975 22.4259 40.5 22.8844 40.5 23.449C40.5 24.0137 40.0975 24.4722 39.6005 24.4722H20.3983C19.9025 24.4722 19.5 24.0137 19.5 23.449Z",
    fill: "#4EBBB8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5273 41.6658H30.47C33.7168 41.6658 35.3397 41.6658 36.3967 40.6322C37.4513 39.5985 37.5587 37.9033 37.7745 34.513L38.086 29.627C38.2027 27.7872 38.261 26.8667 37.7325 26.2845C37.2028 25.7012 36.3092 25.7012 34.5207 25.7012H25.4767C23.6882 25.7012 22.7933 25.7012 22.2648 26.2845C21.7363 26.8678 21.7935 27.7872 21.9113 29.627L22.2228 34.513C22.4387 37.9033 22.546 39.5997 23.6018 40.6322C24.6577 41.6647 26.2805 41.6658 29.5273 41.6658ZM27.9523 30.2197C27.9057 29.7133 27.4763 29.3447 26.9957 29.3948C26.515 29.445 26.1638 29.8965 26.2117 30.4028L26.795 36.543C26.8417 37.0493 27.271 37.418 27.7517 37.3678C28.2335 37.3177 28.5847 36.8662 28.5357 36.3598L27.9523 30.2197ZM33.0028 29.3948C33.4835 29.445 33.8347 29.8965 33.7857 30.4028L33.2023 36.543C33.1557 37.0493 32.7252 37.418 32.2457 37.3678C31.7638 37.3177 31.4127 36.8662 31.4617 36.3598L32.045 30.2197C32.0917 29.7133 32.5233 29.3447 33.0028 29.3948Z",
    fill: "#4EBBB8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteCircle);
export default __webpack_public_path__ + "static/media/delete-circle.82b81b94020ff5a5ab6c72c0910500a6.svg";
export { ForwardRef as ReactComponent };